import { createSelector } from 'reselect';
const selectPublicPortalSettingsState = state => state.publicPortalSettings;
const selectPublicPortalSettingsData = createSelector(selectPublicPortalSettingsState, state => state.data);
export const selectPublicPortalSettingsError = createSelector(selectPublicPortalSettingsState, state => state.error);
export const selectPublicPortalSettingsRequestStatus = createSelector(selectPublicPortalSettingsState, state => state.requestStatus);
export const selectPortalDisplayName = createSelector(selectPublicPortalSettingsData, data => {
  var _data$displayName;
  return (_data$displayName = data === null || data === void 0 ? void 0 : data.displayName) !== null && _data$displayName !== void 0 ? _data$displayName : null;
});
export const selectSupportEmail = createSelector(selectPublicPortalSettingsData, data => {
  var _data$supportEmail;
  return (_data$supportEmail = data === null || data === void 0 ? void 0 : data.supportEmail) !== null && _data$supportEmail !== void 0 ? _data$supportEmail : null;
});
export const selectSupportPhoneNumber = createSelector(selectPublicPortalSettingsData, data => {
  var _data$supportPhoneNum;
  return (_data$supportPhoneNum = data === null || data === void 0 ? void 0 : data.supportPhoneNumber) !== null && _data$supportPhoneNum !== void 0 ? _data$supportPhoneNum : null;
});